module.exports = __webpack_public_path__ + "img/repondre-avis.10c66a5.jpg";